export const shapeSwitch = {
	name: "Shape Switch",
	image:
	  "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/spaceship/shape%20switch.gif",
	sprite_photo:
	  "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/spaceship/sprite%20photo/shape%20switch.png",
	sound: [
	  "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQd8bVWQ45AEkrhsD1rb6F5aE2sUKFETEFKRq4StGdpsV/Shape%20Switch%20left.mp3",
	  "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQd8bVWQ45AEkrhsD1rb6F5aE2sUKFETEFKRq4StGdpsV/Shape%20Switch%20right.mp3",
	  "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQd8bVWQ45AEkrhsD1rb6F5aE2sUKFETEFKRq4StGdpsV/Shape%20Switch%20down.mp3",
	  "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQd8bVWQ45AEkrhsD1rb6F5aE2sUKFETEFKRq4StGdpsV/Shape%20Switch%20up.mp3",
	],
	uri: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQyYC6NJTmqN3WbuxvHMqLMMEYsuHb6QP58Cfop6QCBwm/spaceship/shape%20switch.json",
	properties: {
	  speed: "200",
	  level: "1",
	  fireCapacity: "20",
	  maxFuel: "20000",
	  maxWeapons: "3",
	  maxShields: "3",
	  maxRepairKits: "3",
	  resilience: "1",
	},
  };

  export const joyCon = {
	name: "Joy Con",
	image:
	  "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/spaceship/Joy%20Con.gif",
	sprite_photo:
	  "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/spaceship/sprite%20photo/Joy%20Con.png",
	sound: [
	  "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQd8bVWQ45AEkrhsD1rb6F5aE2sUKFETEFKRq4StGdpsV/Joy%20Con%20left.mp3",
	  "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQd8bVWQ45AEkrhsD1rb6F5aE2sUKFETEFKRq4StGdpsV/Joy%20Con%20right.mp3",
	  "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQd8bVWQ45AEkrhsD1rb6F5aE2sUKFETEFKRq4StGdpsV/Joy%20Con%20down.mp3",
	  "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQd8bVWQ45AEkrhsD1rb6F5aE2sUKFETEFKRq4StGdpsV/Joy%20Con%20up.mp3",
	],
	properties: {
	  speed: "200",
	  level: "1",
	  fireCapacity: "30",
	  maxFuel: "30000",
	  maxWeapons: "5",
	  maxShields: "3",
	  maxRepairKits: "3",
	  resilience: "2",
	},
	uri: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQyYC6NJTmqN3WbuxvHMqLMMEYsuHb6QP58Cfop6QCBwm/spaceship/Joy%20Con.json",
  };
  
  export const elythumShip = {
	name: "Elythum ship",
	image:
	  "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/spaceship/Elythum%20ship.gif",
	sprite_photo:
	  "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/spaceship/sprite%20photo/Elythum%20ship.png",
	sound: [
	  "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQd8bVWQ45AEkrhsD1rb6F5aE2sUKFETEFKRq4StGdpsV/Elythum%20ship%20left.mp3",
	  "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQd8bVWQ45AEkrhsD1rb6F5aE2sUKFETEFKRq4StGdpsV/Elythum%20ship%20right.mp3",
	  "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQd8bVWQ45AEkrhsD1rb6F5aE2sUKFETEFKRq4StGdpsV/Elythum%20ship%20down.mp3",
	  "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQd8bVWQ45AEkrhsD1rb6F5aE2sUKFETEFKRq4StGdpsV/Elythum%20ship%20up.mp3",
	],
	properties: {
	  speed: "200",
	  level: "1",
	  fireCapacity: "40",
	  maxFuel: "40000",
	  maxWeapons: "7",
	  maxShields: "3",
	  maxRepairKits: "3",
	  resilience: "3",
	},
	uri: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQyYC6NJTmqN3WbuxvHMqLMMEYsuHb6QP58Cfop6QCBwm/spaceship/Elythum%20ship.json",
  };
  
  export const spaceships = {
	shapeSwitch,
	joyCon,
	elythumShip,
  };
  
  export const SFM_SPACESHIP_CONTRACT_ADDRESS =
	"0x9b01d2051aB5C8A3286d5871a470787Aba67dB6A";

export const SFM_SPACESHIP_CONTRACT_ABI = [
  {
    "inputs": [],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "approved",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "Approval",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "operator",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "approved",
        "type": "bool"
      }
    ],
    "name": "ApprovalForAll",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "_fromTokenId",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "_toTokenId",
        "type": "uint256"
      }
    ],
    "name": "BatchMetadataUpdate",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "_tokenId",
        "type": "uint256"
      }
    ],
    "name": "MetadataUpdate",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "previousOwner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "OwnershipTransferred",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "Transfer",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "approve",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      }
    ],
    "name": "balanceOf",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "getApproved",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_tokenId",
        "type": "uint256"
      }
    ],
    "name": "getMetadata",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
          },
          {
            "internalType": "string",
            "name": "name",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "image",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "sprite_photo",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "level",
            "type": "string"
          },
          {
            "internalType": "string[]",
            "name": "sounds",
            "type": "string[]"
          },
          {
            "components": [
              {
                "internalType": "string",
                "name": "speed",
                "type": "string"
              },
              {
                "internalType": "string",
                "name": "fireCapacity",
                "type": "string"
              },
              {
                "internalType": "string",
                "name": "maxWeapons",
                "type": "string"
              },
              {
                "internalType": "string",
                "name": "maxShields",
                "type": "string"
              },
              {
                "internalType": "string",
                "name": "maxFuel",
                "type": "string"
              }
            ],
            "internalType": "struct SafemoonSpaceship.Properties",
            "name": "properties",
            "type": "tuple"
          }
        ],
        "internalType": "struct SafemoonSpaceship.Token",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      }
    ],
    "name": "getNftsbyOwner",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
          },
          {
            "internalType": "string",
            "name": "name",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "image",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "sprite_photo",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "level",
            "type": "string"
          },
          {
            "internalType": "string[]",
            "name": "sounds",
            "type": "string[]"
          },
          {
            "components": [
              {
                "internalType": "string",
                "name": "speed",
                "type": "string"
              },
              {
                "internalType": "string",
                "name": "fireCapacity",
                "type": "string"
              },
              {
                "internalType": "string",
                "name": "maxWeapons",
                "type": "string"
              },
              {
                "internalType": "string",
                "name": "maxShields",
                "type": "string"
              },
              {
                "internalType": "string",
                "name": "maxFuel",
                "type": "string"
              }
            ],
            "internalType": "struct SafemoonSpaceship.Properties",
            "name": "properties",
            "type": "tuple"
          }
        ],
        "internalType": "struct SafemoonSpaceship.Token[]",
        "name": "",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      }
    ],
    "name": "getTokenIdsByOwner",
    "outputs": [
      {
        "internalType": "uint256[]",
        "name": "",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "operator",
        "type": "address"
      }
    ],
    "name": "isApprovedForAll",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "name",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "ownerOf",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "renounceOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "string",
        "name": "uri",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_name",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_image",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_sprite_photo",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_level",
        "type": "string"
      },
      {
        "internalType": "string[]",
        "name": "_sounds",
        "type": "string[]"
      },
      {
        "components": [
          {
            "internalType": "string",
            "name": "speed",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "fireCapacity",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "maxWeapons",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "maxShields",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "maxFuel",
            "type": "string"
          }
        ],
        "internalType": "struct SafemoonSpaceship.Properties",
        "name": "_properties",
        "type": "tuple"
      }
    ],
    "name": "safeMint",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "safeTransferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "data",
        "type": "bytes"
      }
    ],
    "name": "safeTransferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "operator",
        "type": "address"
      },
      {
        "internalType": "bool",
        "name": "approved",
        "type": "bool"
      }
    ],
    "name": "setApprovalForAll",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bytes4",
        "name": "interfaceId",
        "type": "bytes4"
      }
    ],
    "name": "supportsInterface",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "symbol",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "tokenMetadata",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      },
      {
        "internalType": "string",
        "name": "name",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "image",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "sprite_photo",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "level",
        "type": "string"
      },
      {
        "components": [
          {
            "internalType": "string",
            "name": "speed",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "fireCapacity",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "maxWeapons",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "maxShields",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "maxFuel",
            "type": "string"
          }
        ],
        "internalType": "struct SafemoonSpaceship.Properties",
        "name": "properties",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "tokenURI",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "transferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "transferOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
];
